import { API_STATUS } from "../../../constants/apiStatus";

export const mealRecipeCountsSliceInitialState = {
  counts: null,
  apiStatus: {
    getCounts: API_STATUS.IDLE,
    updateCounts: API_STATUS.IDLE,
  },
  error: null,
};
